// @flow

import React, { Component } from "react";
import { compose } from "redux";
import { localize } from "redux-i18n";
import classNames from "classnames";
import { TitleSection, Button, Loader, SectionComponent, View } from "@components";
import { StandartReportsLayout, MyReportsTable } from "@modules/reporting/components";

import type { State } from "@store/reducers";
import type { AddEditReportModalType } from "@modules/reporting/reducer/modals/types";

type Props = $Exact<{
  clientId: number,
  defaultReports: Array<Object>,
  myReports: Array<Object>,
  standardTitle: string,

  getReport: Function,
  deleteReport: Function,
  toggleAddEditModal: Function,
  toggleHelpPanel?: Function,
  hideScheduleColumn?: boolean,
  ...PropsFromLocalize,
}>;
type myReportsFilterCriteriaType = "ALL" | "RECENT";
type LocalState = $Exact<{
  myReportsFilter: myReportsFilterCriteriaType,
}>;

export class ReportsPageLayout extends Component<Props, LocalState> {
  state = {
    myReportsFilter: "ALL",
  };

  filterReports = (criteria: myReportsFilterCriteriaType) => () => {
    this.setState({
      ...this.state,
      myReportsFilter: criteria || "ALL",
    });
  };
  get myReports() {
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    return this.state.myReportsFilter === "ALL"
      ? this.props.myReports
      : this.props.myReports.filter((report: Object) => {
          return new Date(report.createdAt) >= sevenDaysAgo;
        });
  }
  render() {
    return (
      <>
        <StandartReportsLayout
          reports={this.props.defaultReports}
          runReport={this.props.getReport}
          title={this.props.standardTitle}
          toggleHelpPanel={this.props.toggleHelpPanel}
        />
        <View gap={4} className="gs-container" padding={["1rem"]}>
          <View direction="row" justifyContent="center" alignItems="center">
            <div className="sub-header d-flex w-100 align-items-center">
              <h6 className="sub-header px-0 mr-3">{this.props.t("MY_REPORTS")}</h6>
              <div className="d-flex justify-content-between align-items-center">
                <Button
                  materialIcon="select_all"
                  className={"mr-2 " + (this.state.myReportsFilter === "ALL" ? "active" : "")}
                  onClick={this.filterReports("ALL")}
                  size="small"
                >
                  {this.props.t("ALL")}
                </Button>
                <Button
                  materialIcon="history"
                  className={this.state.myReportsFilter === "RECENT" ? "active" : ""}
                  onClick={this.filterReports("RECENT")}
                  size="small"
                >
                  {this.props.t("RECENT")}
                </Button>
              </div>
            </div>
            <Button
              onClick={this.props.toggleAddEditModal({
                visible: true,
                initialStep: 1,
              })}
              materialIcon="add_circle"
              className="float-right"
              size="small"
            >
              {this.props.t("NEW_REPORT_CREATE")}
            </Button>
          </View>
          <MyReportsTable
            reports={this.myReports}
            runReport={this.props.getReport}
            clientId={this.props.clientId}
            deleteReport={this.props.deleteReport}
            hideScheduleColumn={this.props.hideScheduleColumn}
          />
        </View>
      </>
    );
  }
}

export default compose(localize())(ReportsPageLayout);
